<template>
  <v-badge class="w-full" overlap :color="chipColor">
    <v-chip
      :class="contentClass"
      :color="background"
      label
      :text-color="color"
      class="w-full"
    >
      {{ label }}
    </v-chip>
    <template #badge>
      <v-icon color="white">{{ icon }}</v-icon>
    </template>
  </v-badge>
</template>

<script>
export default {
  name: "ColorContrastChecker",
  props: {
    label: {
      type: String,
      required: true,
    },
    color: {
      type: String,
      required: true,
    },
    background: {
      type: String,
      required: true,
    },
    contentClass: {
      type: String,
      default: "",
    },
  },
  methods: {
    hexToRgb(hex) {

      hex = hex.replace(/^#/, "");
      if (hex.length === 3) {
        hex = hex
          .split("")
          .map((x) => x + x)
          .join("");
      }
      const bigint = parseInt(hex, 16);
      return [(bigint >> 16) & 255, (bigint >> 8) & 255, bigint & 255];
    },
    luminance([r, g, b]) {
      const sRGB = [r, g, b].map((c) => {
        c /= 255;
        return c <= 0.03928 ? c / 12.92 : ((c + 0.055) / 1.055) ** 2.4;
      });

      return sRGB[0] * 0.2126 + sRGB[1] * 0.7152 + sRGB[2] * 0.0722;
    },

    contrastRatio(color1, color2) {
      const lum1 = this.luminance(this.hexToRgb(color1));
      const lum2 = this.luminance(this.hexToRgb(color2));
      const brightest = Math.max(lum1, lum2);
      const darkest = Math.min(lum1, lum2);
      return (brightest + 0.05) / (darkest + 0.05);
    },
    calculateContrast(background, text) {
      return this.contrastRatio(background, text);
    },
  },

  computed: {
    contrast() {
      return this.calculateContrast(this.background, this.color);
    },
    icon() {
      if (this.contrast >= 7) return "mdi-check-decagram";
      if (this.contrast >= 4.5) return "mdi-check";
      if (this.contrast >= 3) return "mdi-check";
      return "mdi-close";
    },

    chipColor() {
      if (this.contrast >= 7) return "success";
      if (this.contrast >= 4.5) return "success";
      if (this.contrast >= 3) return "warning";
      return "error";
    },
  },
};
</script>
